/* DRW-57: Lock scroll position when the Judge.me reviews widget re-renders.
   Without this, sort changes / "Mehr laden" cause the page to jump up to
   ~440px because the widget's height changes and the browser's default
   scroll-anchoring does not hold the widget itself in place. */
(function () {
  'use strict';
  if (window.__drwJdgmScrollLockInit) return;
  window.__drwJdgmScrollLockInit = true;

  var WIDGET_SELECTOR = '.jdgm-rev-widg';
  var pendingTop = null;
  var pendingHeight = 0;
  var pendingTimer = null;
  var settleTimer = null;
  var rafId = null;
  var rafTicks = 0;
  var rafCorrections = 0;
  var SETTLE_MS = 150; // release debounce after last mutation

  function instantScrollBy(delta) {
    inOurOwnCall = true;
    try {
      window.scrollBy({ top: delta, left: 0, behavior: 'instant' });
    } catch (e) {
      window.scrollBy(0, delta);
    } finally {
      inOurOwnCall = false;
    }
  }

  // ===== DIAGNOSTIC INSTRUMENTATION =====
  // Wraps every API that can move scroll position. When debug is on AND we
  // are in a lock window, every call is logged with a short stack trace so
  // we can identify the scroll-mover (Judge.me, browser scroll-anchoring,
  // our own code, or something else).
  var diagInstalled = false;
  var origScrollTo, origScrollBy, origScrollIntoView, origFocus;
  var diagScrollTopDescriptor;
  var inOurOwnCall = false;

  function shortStack() {
    try {
      throw new Error();
    } catch (e) {
      var lines = (e.stack || '').split('\n').slice(2, 6).map(function (l) { return l.trim(); });
      return lines.join(' | ');
    }
  }

  function diagLog(label, info) {
    if (!window.__drwJdgmDebug) return;
    if (pendingTop === null) return; // only inside lock window
    if (inOurOwnCall) return;
    console.log('[drw-jdgm:DIAG] ' + label, info, '|stack:', shortStack());
  }

  function installDiag() {
    if (diagInstalled) return;
    diagInstalled = true;

    origScrollTo = window.scrollTo;
    origScrollBy = window.scrollBy;
    origScrollIntoView = Element.prototype.scrollIntoView;
    origFocus = HTMLElement.prototype.focus;

    window.scrollTo = function () {
      diagLog('window.scrollTo', Array.prototype.slice.call(arguments));
      return origScrollTo.apply(window, arguments);
    };
    window.scrollBy = function () {
      diagLog('window.scrollBy', Array.prototype.slice.call(arguments));
      return origScrollBy.apply(window, arguments);
    };
    Element.prototype.scrollIntoView = function () {
      diagLog('Element.scrollIntoView', { tag: this.tagName, cls: this.className, id: this.id, args: Array.prototype.slice.call(arguments) });
      return origScrollIntoView.apply(this, arguments);
    };
    HTMLElement.prototype.focus = function () {
      // focus() can scroll if preventScroll is not set; log only if in lock
      if (window.__drwJdgmDebug && pendingTop !== null && !inOurOwnCall) {
        console.log('[drw-jdgm:DIAG] HTMLElement.focus', { tag: this.tagName, cls: this.className, id: this.id });
      }
      return origFocus.apply(this, arguments);
    };

    // scrollTop setter on Element. Stiletto's inline smooth-scroll animation
    // assigns scrollTop directly on <html> and <body> every frame. During a
    // lock window we BLOCK those assignments (no-op) — that stops the
    // animation from drifting the page while Judge.me is rebuilding the
    // reviews list. Sub-element scrolls (inside scrollable divs) pass through.
    var proto = Element.prototype;
    diagScrollTopDescriptor = Object.getOwnPropertyDescriptor(proto, 'scrollTop');
    if (diagScrollTopDescriptor && diagScrollTopDescriptor.set) {
      var origSetter = diagScrollTopDescriptor.set;
      var origGetter = diagScrollTopDescriptor.get;
      Object.defineProperty(proto, 'scrollTop', {
        configurable: true,
        get: function () { return origGetter.call(this); },
        set: function (v) {
          var isPageScroller = this === document.documentElement || this === document.body;
          if (pendingTop !== null && !inOurOwnCall && isPageScroller) {
            // Block external page-scroll writes during lock window.
            if (window.__drwJdgmDebug) {
              console.log('[drw-jdgm:DIAG] BLOCKED scrollTop=', { tag: this.tagName, value: v });
            }
            return;
          }
          diagLog('Element.scrollTop=', { tag: this.tagName, cls: this.className, id: this.id, value: v });
          return origSetter.call(this, v);
        }
      });
    }

    // scroll event listener at document — logs scroll fires during lock
    document.addEventListener('scroll', function () {
      if (window.__drwJdgmDebug && pendingTop !== null && !inOurOwnCall) {
        console.log('[drw-jdgm:DIAG] scroll event', { scrollY: window.scrollY });
      }
    }, true);
  }
  installDiag();

  function getWidget() {
    return document.querySelector(WIDGET_SELECTOR);
  }

  // Element that actually collapses during AJAX — Judge.me empties this
  // div and replaces with a spinner while waiting for the new review list.
  // Locking only the outer .jdgm-rev-widg is not enough because the body
  // child still shrinks to ~40 px (spinner only) and the widget container's
  // intrinsic height drops with it. We lock the body explicitly.
  function getBody() {
    return document.querySelector('.jdgm-rev-widg .jdgm-rev-widg__body');
  }

  function snapshot() {
    var w = getWidget();
    var body = getBody();
    if (!w) return;
    var rect = w.getBoundingClientRect();
    pendingTop = rect.top;
    pendingHeight = rect.height;
    var bodyHeight = body ? body.getBoundingClientRect().height : 0;
    // Lock both the outer widget and the inner body. The body is what
    // Judge.me clears; locking it prevents the visible collapse inside the
    // widget. Locking the outer widget too is a belt-and-braces measure.
    w.style.setProperty('min-height', pendingHeight + 'px', 'important');
    if (body && bodyHeight > 0) {
      body.style.setProperty('min-height', bodyHeight + 'px', 'important');
    }
    // Disable browser scroll-anchoring during the AJAX window so the browser
    // does not adjust scroll position when the widget DOM is replaced.
    document.documentElement.style.setProperty('overflow-anchor', 'none', 'important');
    if (window.__drwJdgmDebug) {
      console.log('[drw-jdgm] snapshot', { top: pendingTop, h: pendingHeight, bodyH: bodyHeight, scrollY: window.scrollY });
    }
    rafTicks = 0;
    rafCorrections = 0;
    if (rafId !== null) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(rafLoop);
    // Hard safety: release after 6 s no matter what.
    if (pendingTimer) clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { releaseLock(); }, 6000);
  }

  function rafLoop() {
    if (pendingTop === null) { rafId = null; return; }
    rafTicks++;
    var w = getWidget();
    if (w) {
      var newTop = w.getBoundingClientRect().top;
      var delta = newTop - pendingTop;
      if (Math.abs(delta) > 1) {
        instantScrollBy(delta);
        rafCorrections++;
      }
    }
    rafId = requestAnimationFrame(rafLoop);
  }

  function releaseLock() {
    var w = getWidget();
    var body = getBody();
    if (w) w.style.removeProperty('min-height');
    if (body) body.style.removeProperty('min-height');
    document.documentElement.style.removeProperty('overflow-anchor');
    if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    if (window.__drwJdgmDebug) console.log('[drw-jdgm] released');
    pendingTop = null;
    pendingHeight = 0;
    if (pendingTimer) { clearTimeout(pendingTimer); pendingTimer = null; }
    if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
  }

  function restore() {
    if (pendingTop === null) return;
    var w = getWidget();
    if (w) {
      var delta = w.getBoundingClientRect().top - pendingTop;
      if (Math.abs(delta) > 1) instantScrollBy(delta);
    }
    releaseLock();
  }

  // User-initiated triggers we know cause re-renders:
  //   - sort dropdown change (only the visible "Sort dropdown" select; the
  //     reviewer-name-format select reuses the same class but is hidden)
  //   - pagination / "Mehr laden" click
  // We listen for both `input` and `change` in capture phase so we run before
  // Judge.me's own handler which clears the widget DOM.
  function onSortInteraction(e) {
    var t = e.target;
    if (t && t.matches && t.matches('select.jdgm-sort-dropdown[aria-label="Sort dropdown"]')) {
      snapshot();
    }
  }
  document.addEventListener('input', onSortInteraction, true);
  document.addEventListener('change', onSortInteraction, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.jdgm-paginate__link, .jdgm-paginate, [data-page], .jdgm-load-more')) {
      snapshot();
    }
  }, true);

  // Release once mutations have settled. Each mutation resets the timer, so
  // we release N ms after the LAST observed mutation (not the first). This
  // covers Judge.me's multi-step DOM swap (reviews replaced one-by-one over
  // several mutation batches separated by ~16 ms paint frames).
  function scheduleRestore() {
    if (settleTimer) clearTimeout(settleTimer);
    if (window.__drwJdgmDebug) console.log('[drw-jdgm] settle reset');
    settleTimer = setTimeout(function () {
      settleTimer = null;
      if (window.__drwJdgmDebug) {
        var w = getWidget();
        var body = getBody();
        console.log('[drw-jdgm] about to restore', {
          widgetTop: w ? w.getBoundingClientRect().top : null,
          widgetH: w ? w.getBoundingClientRect().height : null,
          bodyH: body ? body.getBoundingClientRect().height : null,
          scrollY: window.scrollY,
          rafTicks: rafTicks,
          rafCorrections: rafCorrections,
          currentReviewCount: document.querySelectorAll('.jdgm-rev-widg .jdgm-rev').length
        });
      }
      restore();
    }, SETTLE_MS);
  }

  // DRW-57b: a number of imported seller replies have their reply body set
  // to a raw timestamp string (e.g. "2021-09-14 00:00:00 UTC"). Hide those so
  // visitors don't see meaningless dates labelled "Dr. Wunder antwortete:".
  // The actual reply text needs to be fixed in Judge.me admin separately.
  var TIMESTAMP_RE = /^\s*\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}\s+UTC\s*$/i;
  function cleanupBogusReplies(root) {
    if (!root || !root.querySelectorAll) return;
    var contents = root.querySelectorAll('.jdgm-rev__reply-content');
    for (var i = 0; i < contents.length; i++) {
      var c = contents[i];
      if (TIMESTAMP_RE.test(c.textContent)) {
        var reply = c.closest('.jdgm-rev__reply');
        if (reply) reply.style.display = 'none';
      }
    }
  }

  var observer = (typeof MutationObserver !== 'undefined')
    ? new MutationObserver(function (records) {
        var sawChildChange = false;
        var addedTotal = 0, removedTotal = 0, addedReviews = 0, removedReviews = 0;
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (r.addedNodes.length || r.removedNodes.length) {
            sawChildChange = true;
            addedTotal += r.addedNodes.length;
            removedTotal += r.removedNodes.length;
            for (var j = 0; j < r.addedNodes.length; j++) {
              var addedNode = r.addedNodes[j];
              if (addedNode.nodeType === 1) {
                if (addedNode.matches && addedNode.matches('.jdgm-rev')) addedReviews++;
                else if (addedNode.querySelector && addedNode.querySelector('.jdgm-rev')) addedReviews++;
              }
              cleanupBogusReplies(addedNode);
            }
            for (var k = 0; k < r.removedNodes.length; k++) {
              var removedNode = r.removedNodes[k];
              if (removedNode.nodeType === 1) {
                if (removedNode.matches && removedNode.matches('.jdgm-rev')) removedReviews++;
                else if (removedNode.querySelector && removedNode.querySelector('.jdgm-rev')) removedReviews++;
              }
            }
          }
        }
        if (window.__drwJdgmDebug && sawChildChange) {
          var w = getWidget();
          var body = getBody();
          console.log('[drw-jdgm] mutation', {
            addedTotal: addedTotal,
            removedTotal: removedTotal,
            addedReviews: addedReviews,
            removedReviews: removedReviews,
            pendingTop: pendingTop,
            widgetTop: w ? w.getBoundingClientRect().top : null,
            widgetH: w ? w.getBoundingClientRect().height : null,
            bodyH: body ? body.getBoundingClientRect().height : null,
            currentReviewCount: document.querySelectorAll('.jdgm-rev-widg .jdgm-rev').length
          });
        }
        if (sawChildChange && pendingTop !== null) scheduleRestore();
      })
    : null;

  // Widget is lazy-loaded by Judge.me's loader.js. Poll briefly for it to
  // appear, then start observing. Stop polling after 30s.
  var attempts = 0;
  function tryAttach() {
    var w = getWidget();
    if (w) {
      // Run cleanup once now in case the widget is already populated by the
      // time we attached (cached navigation, slow networks, etc.).
      cleanupBogusReplies(w);
      if (observer) observer.observe(w, { childList: true, subtree: true });
      return;
    }
    if (++attempts < 60) setTimeout(tryAttach, 500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryAttach);
  } else {
    tryAttach();
  }
})();
